"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.schemaFichaSaude = exports.yupFichaSaude = void 0;
const yup = __importStar(require("yup"));
const utils_1 = require("../utils");
const enums_1 = require("../enums");
exports.yupFichaSaude = yup.object({
    idAluno: yup.number().required().positive().integer().label('Aluno'),
    tipo: yup.string().max(200, 'Máximo de 200 caracteres.').default('').label(''),
    contato2: yup.string().max(256, 'Máximo de 256 caracteres.').default('').label('Contato de emergência 2'),
    contato1: yup.string().max(256, 'Máximo de 256 caracteres.').default('').label('Contato de emergência 1'),
    multipla: yup.boolean().required().default(false).label('Deficiência múltipla'),
    plano: yup.string().max(256, 'Máximo de 256 caracteres.').default('').label('Plano de saúde'),
    vacinaDt: (0, utils_1.sge2Date)().nullable().default(null).label('Data Vacina'),
    sangue: yup.mixed().label('Tipo Sanguíneo').nullable().default(enums_1.ETipoSanguineo.Nenhum),
    clinica: yup.string().max(256, 'Máximo de 256 caracteres.').default('').label('Clínica'),
    super: yup.boolean().required().default(false).label('Altas habilidades/superdotação'),
    neuromotor: yup.boolean().required().default(false).label('Deficiência Neuromotora grave'),
    autista: yup.boolean().required().default(false).label('Transtorno de Espectro Autista'),
    diabetes: yup.boolean().required().default(false).label('Diabetes'),
    outra: yup.string().max(256, 'Máximo de 256 caracteres.').default('').label('Outra'),
    hipotensao: yup.boolean().required().default(false).label('Hipotensão'),
    hipertenso: yup.boolean().required().default(false).label('Hipertensão'),
    hemofilia: yup.boolean().required().default(false).label('Hemofilia'),
    cardiopata: yup.boolean().required().default(false).label('Cardiopatia'),
    convulsao: yup.boolean().required().default(false).label('Convulsão/Doença Neurológica'),
    tireoide: yup.boolean().required().default(false).label('Tireóide'),
    rinite: yup.boolean().required().default(false).label('Rinite alérgica'),
    cjuntivite: yup.boolean().required().default(false).label('Conjuntivite'),
    asma: yup.boolean().required().default(false).label('Asma/Bronquite'),
    pomada: yup.boolean().required().default(false).label('Alergia a Pomadas'),
    corante: yup.boolean().required().default(false).label('Alergia a Corante'),
    inseto: yup.boolean().required().default(false).label('Alergia de picada de inseto'),
    leite: yup.boolean().required().default(false).label('Alergia de Leite'),
    ovo: yup.boolean().required().default(false).label('Alergia a ovo'),
    cirurgia: yup.string().max(256, 'Máximo de 256 caracteres.').default('').label('Fez cirurgia'),
    doenca: yup.string().max(256, 'Máximo de 256 caracteres.').default('').label('Teve doenças graves no passado'),
    psicologo: yup.string().max(256, 'Máximo de 256 caracteres.').default('').label('Acompanhamento Psicológico'),
    pedagogo: yup.string().max(256, 'Máximo de 256 caracteres.').default('').label('Acompanhamento Psicopedagógico'),
    fono: yup.string().max(256, 'Máximo de 256 caracteres.').default('').label('Acompanhamento Fonoaudiológico'),
    remedio: yup.string().max(256, 'Máximo de 256 caracteres.').default('').label('Medicamento de uso contínuo'),
    atividades: yup
        .string()
        .max(256, 'Máximo de 256 caracteres.')
        .default('')
        .label('Restrição para fazer atividade física'),
    medico: yup.string().max(256, 'Máximo de 256 caracteres.').default('').label('Acompanhamento médico'),
    aremedio: yup.boolean().required().default(false).label('Alergia a medicamentos/remédio'),
    alimentar: yup.string().max(256, 'Máximo de 256 caracteres.').default('').label('Outras Alergias'),
    fisico: yup
        .boolean()
        .required()
        .default(false)
        .label('Transtorno específico do desenvolvimento de função motora (deficiência física)'),
    visual: yup.string().max(100, 'Máximo de 100 caracteres.').default('').label('Deficiência visual'),
    auditivo: yup
        .string()
        .max(100, 'Máximo de 100 caracteres.')
        .default('')
        .label('Defasagem no Processo Auditivo Central (P.A.C)'),
    mental: yup
        .boolean()
        .required()
        .default(false)
        .label('Defasagem entre a idade cronologia e intelectual (deficiência mental)'),
    discalculi: yup.boolean().required().default(false).label('Transtorno específico das habilidades matemáticas'),
    linguagem: yup.boolean().required().default(false).label('Transtorno específico da linguagem'),
    emocional: yup.boolean().required().default(false).label('Transtorno emocional e do comportamento'),
    nee: yup.boolean().required().default(false).label('Necessidades educativas e/ou de atendimento especiais'),
    tdah: yup.boolean().required().default(false).label('Transtorno do Distúrbio da Atenção/Hiperatividade'),
});
exports.schemaFichaSaude = exports.yupFichaSaude.shape({});
